import React, {useEffect, useState} from 'react'
import {Badge, Card, CardContent, IconButton, Menu, MenuItem, Typography} from '@mui/material'
import NotificationsIcon from '@mui/icons-material/Notifications'

export type Notification = {
    sku: string
}

const NotificationCard = ({sku}: {sku: string}) => (
    <Card style={{margin: '8px', cursor: 'pointer'}}>
        <CardContent>
            <Typography variant="h6">Item Deserialized: {sku}</Typography>
            <Typography>
                Item {sku} was deserialized, please remove from the serial bag
                and recount.
            </Typography>
        </CardContent>
    </Card>
)

const Notifications = ({
                           notificationList
                       }: {
    notificationList: Notification[]
}) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [notifications, setNotifications] = useState<Notification[]>([])
    const [checkedNotification, setNotificationChecked] = useState(true)

    useEffect(() => {
        setNotifications(notificationList)
        setNotificationChecked(notificationList.length <= 0)
    }, [notificationList])

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
        setNotificationChecked(true)
    }

    return (
        <div>
            <IconButton onClick={handleClick}>
                <Badge
                    color="error"
                    variant={checkedNotification ? 'standard' : 'dot'}>
                    <NotificationsIcon color="action" />
                </Badge>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                {notifications.length === 0 ? (
                    <MenuItem>
                        <Typography>No notifications</Typography>
                    </MenuItem>
                ) : (
                    notifications.map(
                        (
                            notification: {sku: string},
                            index: React.Key | null | undefined
                        ) => (
                            <MenuItem key={index}>
                                <NotificationCard sku={notification.sku} />
                            </MenuItem>
                        )
                    )
                )}
            </Menu>
        </div>
    )
}

export default Notifications
